import {Center, GridItem, HStack, Icon, Show, Text} from 'platform/foundation';
import styled from 'styled-components';

import {isNil, isNotNil} from 'ramda';

import {Nullish, TestIdProps} from 'shared/web';

import {PositionedDashboardGridTile} from '../../utils/allocateDashboardGrid';
import {TileDropPlacement} from '../../utils/resolveTileDropPlacement';
import {toDashboardGridPlacement} from '../../utils/toDashboardGridPlacement';

interface DashboardDropGhostProps extends TestIdProps {
  cell: PositionedDashboardGridTile | Nullish;
  placement?: TileDropPlacement | Nullish;
  label?: string | Nullish;
  isInvalid?: boolean;
}

interface StyledGhostProps {
  $isInvalid: boolean;
}

const StyledGhost = styled.div<StyledGhostProps>`
  height: 100%;
  position: relative;
  z-index: 1;
  border: ${({theme}) => theme.getSize(1)} dashed
    ${({$isInvalid, theme}) =>
      $isInvalid ? theme.colors.severity.danger : theme.colors.general.accent};
  border-radius: ${({theme}) => theme.radii.medium};
  background: ${({$isInvalid, theme}) =>
    $isInvalid ? theme.colors.palettes.red[20][100] : theme.colors.palettes.blue[20][100]};
  pointer-events: none;
`;

export function DashboardDropGhost(props: DashboardDropGhostProps) {
  if (isNil(props.cell)) {
    return null;
  }

  return (
    <GridItem {...toDashboardGridPlacement(props.cell)}>
      <StyledGhost
        $isInvalid={props.isInvalid ?? false}
        data-column={props.cell.column}
        data-row={props.cell.row}
        data-invalid={props.isInvalid ? 'true' : undefined}
        data-placement={props.placement ?? undefined}
        data-testid={props['data-testid']}
      >
        <Show when={isNotNil(props.label)}>
          <Center height="100%">
            <HStack spacing={1} align="center">
              <Icon value="action/swap_horiz" size={4} color="general.accent" />
              <Text size="xSmall" color="link">
                {props.label}
              </Text>
            </HStack>
          </Center>
        </Show>
      </StyledGhost>
    </GridItem>
  );
}
